export const USER_GET_COMPANY_ACTIONS_BEGIN = 'USER_GET_COMPANY_ACTIONS_BEGIN';
export const USER_GET_COMPANY_ACTIONS_SUCCESS = 'USER_GET_COMPANY_ACTIONS_SUCCESS';
export const USER_GET_COMPANY_ACTIONS_FAILURE = 'USER_GET_COMPANY_ACTIONS_FAILURE';
export const USER_GET_COMPANY_ACTIONS_DISMISS_ERROR = 'USER_GET_COMPANY_ACTIONS_DISMISS_ERROR';
export const USER_COMPANY_SHOW_FORM = 'USER_COMPANY_SHOW_FORM';
export const USER_CHANGE_COMPANY_ACTIONS_BEGIN = 'USER_CHANGE_COMPANY_ACTIONS_BEGIN';
export const USER_CHANGE_COMPANY_ACTIONS_SUCCESS = 'USER_CHANGE_COMPANY_ACTIONS_SUCCESS';
export const USER_CHANGE_COMPANY_ACTIONS_FAILURE = 'USER_CHANGE_COMPANY_ACTIONS_FAILURE';
export const USER_CHANGE_COMPANY_ACTIONS_DISMISS_ERROR = 'USER_CHANGE_COMPANY_ACTIONS_DISMISS_ERROR';
export const USER_CHANGE_COMPANY = 'USER_CHANGE_COMPANY';
export const USER_GET_FRUI_ZZZZ_LIST_BEGIN = 'USER_GET_FRUI_ZZZZ_LIST_BEGIN';
export const USER_GET_FRUI_ZZZZ_LIST_SUCCESS = 'USER_GET_FRUI_ZZZZ_LIST_SUCCESS';
export const USER_GET_FRUI_ZZZZ_LIST_FAILURE = 'USER_GET_FRUI_ZZZZ_LIST_FAILURE';
export const USER_GET_FRUI_ZZZZ_LIST_DISMISS_ERROR = 'USER_GET_FRUI_ZZZZ_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_ZZZZ_BEGIN = 'USER_SUBMIT_FRUI_ZZZZ_BEGIN';
export const USER_SUBMIT_FRUI_ZZZZ_SUCCESS = 'USER_SUBMIT_FRUI_ZZZZ_SUCCESS';
export const USER_SUBMIT_FRUI_ZZZZ_FAILURE = 'USER_SUBMIT_FRUI_ZZZZ_FAILURE';
export const USER_SUBMIT_FRUI_ZZZZ_DISMISS_ERROR = 'USER_SUBMIT_FRUI_ZZZZ_DISMISS_ERROR';
export const USER_DELETE_FRUI_ZZZZ_BEGIN = 'USER_DELETE_FRUI_ZZZZ_BEGIN';
export const USER_DELETE_FRUI_ZZZZ_SUCCESS = 'USER_DELETE_FRUI_ZZZZ_SUCCESS';
export const USER_DELETE_FRUI_ZZZZ_FAILURE = 'USER_DELETE_FRUI_ZZZZ_FAILURE';
export const USER_DELETE_FRUI_ZZZZ_DISMISS_ERROR = 'USER_DELETE_FRUI_ZZZZ_DISMISS_ERROR';
export const USER_FRUI_ZZZZ_MODAL_CHANGE = 'USER_FRUI_ZZZZ_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_ZZZZ = 'USER_CHOOSE_CURRENT_FRUI_ZZZZ';
export const USER_GET_FRUI_QPFJ_LIST_BEGIN = 'USER_GET_FRUI_QPFJ_LIST_BEGIN';
export const USER_GET_FRUI_QPFJ_LIST_SUCCESS = 'USER_GET_FRUI_QPFJ_LIST_SUCCESS';
export const USER_GET_FRUI_QPFJ_LIST_FAILURE = 'USER_GET_FRUI_QPFJ_LIST_FAILURE';
export const USER_GET_FRUI_QPFJ_LIST_DISMISS_ERROR = 'USER_GET_FRUI_QPFJ_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_QPFJ_BEGIN = 'USER_SUBMIT_FRUI_QPFJ_BEGIN';
export const USER_SUBMIT_FRUI_QPFJ_SUCCESS = 'USER_SUBMIT_FRUI_QPFJ_SUCCESS';
export const USER_SUBMIT_FRUI_QPFJ_FAILURE = 'USER_SUBMIT_FRUI_QPFJ_FAILURE';
export const USER_SUBMIT_FRUI_QPFJ_DISMISS_ERROR = 'USER_SUBMIT_FRUI_QPFJ_DISMISS_ERROR';
export const USER_DELETE_FRUI_QPFJ_BEGIN = 'USER_DELETE_FRUI_QPFJ_BEGIN';
export const USER_DELETE_FRUI_QPFJ_SUCCESS = 'USER_DELETE_FRUI_QPFJ_SUCCESS';
export const USER_DELETE_FRUI_QPFJ_FAILURE = 'USER_DELETE_FRUI_QPFJ_FAILURE';
export const USER_DELETE_FRUI_QPFJ_DISMISS_ERROR = 'USER_DELETE_FRUI_QPFJ_DISMISS_ERROR';
export const USER_FRUI_QPFJ_MODAL_CHANGE = 'USER_FRUI_QPFJ_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_QPFJ = 'USER_CHOOSE_CURRENT_FRUI_QPFJ';
export const USER_GET_FRUI_QPBZ_LIST_BEGIN = 'USER_GET_FRUI_QPBZ_LIST_BEGIN';
export const USER_GET_FRUI_QPBZ_LIST_SUCCESS = 'USER_GET_FRUI_QPBZ_LIST_SUCCESS';
export const USER_GET_FRUI_QPBZ_LIST_FAILURE = 'USER_GET_FRUI_QPBZ_LIST_FAILURE';
export const USER_GET_FRUI_QPBZ_LIST_DISMISS_ERROR = 'USER_GET_FRUI_QPBZ_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_QPBZ_BEGIN = 'USER_SUBMIT_FRUI_QPBZ_BEGIN';
export const USER_SUBMIT_FRUI_QPBZ_SUCCESS = 'USER_SUBMIT_FRUI_QPBZ_SUCCESS';
export const USER_SUBMIT_FRUI_QPBZ_FAILURE = 'USER_SUBMIT_FRUI_QPBZ_FAILURE';
export const USER_SUBMIT_FRUI_QPBZ_DISMISS_ERROR = 'USER_SUBMIT_FRUI_QPBZ_DISMISS_ERROR';
export const USER_DELETE_FRUI_QPBZ_BEGIN = 'USER_DELETE_FRUI_QPBZ_BEGIN';
export const USER_DELETE_FRUI_QPBZ_SUCCESS = 'USER_DELETE_FRUI_QPBZ_SUCCESS';
export const USER_DELETE_FRUI_QPBZ_FAILURE = 'USER_DELETE_FRUI_QPBZ_FAILURE';
export const USER_DELETE_FRUI_QPBZ_DISMISS_ERROR = 'USER_DELETE_FRUI_QPBZ_DISMISS_ERROR';
export const USER_FRUI_QPBZ_MODAL_CHANGE = 'USER_FRUI_QPBZ_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_QPBZ = 'USER_CHOOSE_CURRENT_FRUI_QPBZ';
export const USER_GET_FRUI_QPXH_LIST_BEGIN = 'USER_GET_FRUI_QPXH_LIST_BEGIN';
export const USER_GET_FRUI_QPXH_LIST_SUCCESS = 'USER_GET_FRUI_QPXH_LIST_SUCCESS';
export const USER_GET_FRUI_QPXH_LIST_FAILURE = 'USER_GET_FRUI_QPXH_LIST_FAILURE';
export const USER_GET_FRUI_QPXH_LIST_DISMISS_ERROR = 'USER_GET_FRUI_QPXH_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_QPXH_BEGIN = 'USER_SUBMIT_FRUI_QPXH_BEGIN';
export const USER_SUBMIT_FRUI_QPXH_SUCCESS = 'USER_SUBMIT_FRUI_QPXH_SUCCESS';
export const USER_SUBMIT_FRUI_QPXH_FAILURE = 'USER_SUBMIT_FRUI_QPXH_FAILURE';
export const USER_SUBMIT_FRUI_QPXH_DISMISS_ERROR = 'USER_SUBMIT_FRUI_QPXH_DISMISS_ERROR';
export const USER_DELETE_FRUI_QPXH_BEGIN = 'USER_DELETE_FRUI_QPXH_BEGIN';
export const USER_DELETE_FRUI_QPXH_SUCCESS = 'USER_DELETE_FRUI_QPXH_SUCCESS';
export const USER_DELETE_FRUI_QPXH_FAILURE = 'USER_DELETE_FRUI_QPXH_FAILURE';
export const USER_DELETE_FRUI_QPXH_DISMISS_ERROR = 'USER_DELETE_FRUI_QPXH_DISMISS_ERROR';
export const USER_FRUI_QPXH_MODAL_CHANGE = 'USER_FRUI_QPXH_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_QPXH = 'USER_CHOOSE_CURRENT_FRUI_QPXH';
export const USER_GET_FRUI_PFBZ_LIST_BEGIN = 'USER_GET_FRUI_PFBZ_LIST_BEGIN';
export const USER_GET_FRUI_PFBZ_LIST_SUCCESS = 'USER_GET_FRUI_PFBZ_LIST_SUCCESS';
export const USER_GET_FRUI_PFBZ_LIST_FAILURE = 'USER_GET_FRUI_PFBZ_LIST_FAILURE';
export const USER_GET_FRUI_PFBZ_LIST_DISMISS_ERROR = 'USER_GET_FRUI_PFBZ_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_PFBZ_BEGIN = 'USER_SUBMIT_FRUI_PFBZ_BEGIN';
export const USER_SUBMIT_FRUI_PFBZ_SUCCESS = 'USER_SUBMIT_FRUI_PFBZ_SUCCESS';
export const USER_SUBMIT_FRUI_PFBZ_FAILURE = 'USER_SUBMIT_FRUI_PFBZ_FAILURE';
export const USER_SUBMIT_FRUI_PFBZ_DISMISS_ERROR = 'USER_SUBMIT_FRUI_PFBZ_DISMISS_ERROR';
export const USER_DELETE_FRUI_PFBZ_BEGIN = 'USER_DELETE_FRUI_PFBZ_BEGIN';
export const USER_DELETE_FRUI_PFBZ_SUCCESS = 'USER_DELETE_FRUI_PFBZ_SUCCESS';
export const USER_DELETE_FRUI_PFBZ_FAILURE = 'USER_DELETE_FRUI_PFBZ_FAILURE';
export const USER_DELETE_FRUI_PFBZ_DISMISS_ERROR = 'USER_DELETE_FRUI_PFBZ_DISMISS_ERROR';
export const USER_FRUI_PFBZ_MODAL_CHANGE = 'USER_FRUI_PFBZ_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_PFBZ = 'USER_CHOOSE_CURRENT_FRUI_PFBZ';
export const USER_GET_FRUI_PFXH_LIST_BEGIN = 'USER_GET_FRUI_PFXH_LIST_BEGIN';
export const USER_GET_FRUI_PFXH_LIST_SUCCESS = 'USER_GET_FRUI_PFXH_LIST_SUCCESS';
export const USER_GET_FRUI_PFXH_LIST_FAILURE = 'USER_GET_FRUI_PFXH_LIST_FAILURE';
export const USER_GET_FRUI_PFXH_LIST_DISMISS_ERROR = 'USER_GET_FRUI_PFXH_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_PFXH_BEGIN = 'USER_SUBMIT_FRUI_PFXH_BEGIN';
export const USER_SUBMIT_FRUI_PFXH_SUCCESS = 'USER_SUBMIT_FRUI_PFXH_SUCCESS';
export const USER_SUBMIT_FRUI_PFXH_FAILURE = 'USER_SUBMIT_FRUI_PFXH_FAILURE';
export const USER_SUBMIT_FRUI_PFXH_DISMISS_ERROR = 'USER_SUBMIT_FRUI_PFXH_DISMISS_ERROR';
export const USER_DELETE_FRUI_PFXH_BEGIN = 'USER_DELETE_FRUI_PFXH_BEGIN';
export const USER_DELETE_FRUI_PFXH_SUCCESS = 'USER_DELETE_FRUI_PFXH_SUCCESS';
export const USER_DELETE_FRUI_PFXH_FAILURE = 'USER_DELETE_FRUI_PFXH_FAILURE';
export const USER_DELETE_FRUI_PFXH_DISMISS_ERROR = 'USER_DELETE_FRUI_PFXH_DISMISS_ERROR';
export const USER_FRUI_PFXH_MODAL_CHANGE = 'USER_FRUI_PFXH_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_PFXH = 'USER_CHOOSE_CURRENT_FRUI_PFXH';
export const USER_CHOOSE_CURRENT_FRUI_ZZZZ_MODEL_SHOW = 'USER_CHOOSE_CURRENT_FRUI_ZZZZ_MODEL_SHOW';
export const USER_FRUI_PFXHTYPE_TESTS_MODAL_CHANGE = 'USER_FRUI_PFXHTYPE_TESTS_MODAL_CHANGE';
export const USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_BEGIN = 'USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_BEGIN';
export const USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_SUCCESS = 'USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_SUCCESS';
export const USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_FAILURE = 'USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_FAILURE';
export const USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_DISMISS_ERROR = 'USER_SUBMIT_FRUI_PFXH_TYPE_TESTS_DISMISS_ERROR';
export const USER_CHANGE_CURRENT_FRUI_PFXH_TYPE_TESTS = 'USER_CHANGE_CURRENT_FRUI_PFXH_TYPE_TESTS';
export const USER_UPLOADING_YYZZ_ACTIONS_BEGIN = 'USER_UPLOADING_YYZZ_ACTIONS_BEGIN';
export const USER_UPLOADING_YYZZ_ACTIONS_SUCCESS = 'USER_UPLOADING_YYZZ_ACTIONS_SUCCESS';
export const USER_UPLOADING_YYZZ_ACTIONS_FAILURE = 'USER_UPLOADING_YYZZ_ACTIONS_FAILURE';
export const USER_UPLOADING_YYZZ_ACTIONS_DISMISS_ERROR = 'USER_UPLOADING_YYZZ_ACTIONS_DISMISS_ERROR';
export const USER_UPLOADING_SEAL_ACTIONS_BEGIN = 'USER_UPLOADING_SEAL_ACTIONS_BEGIN';
export const USER_UPLOADING_SEAL_ACTIONS_SUCCESS = 'USER_UPLOADING_SEAL_ACTIONS_SUCCESS';
export const USER_UPLOADING_SEAL_ACTIONS_FAILURE = 'USER_UPLOADING_SEAL_ACTIONS_FAILURE';
export const USER_UPLOADING_SEAL_ACTIONS_DISMISS_ERROR = 'USER_UPLOADING_SEAL_ACTIONS_DISMISS_ERROR';
export const USER_UPLOADING_XKZ_ACTIONS_BEGIN = 'USER_UPLOADING_XKZ_ACTIONS_BEGIN';
export const USER_UPLOADING_XKZ_ACTIONS_SUCCESS = 'USER_UPLOADING_XKZ_ACTIONS_SUCCESS';
export const USER_UPLOADING_XKZ_ACTIONS_FAILURE = 'USER_UPLOADING_XKZ_ACTIONS_FAILURE';
export const USER_UPLOADING_XKZ_ACTIONS_DISMISS_ERROR = 'USER_UPLOADING_XKZ_ACTIONS_DISMISS_ERROR';
export const USER_GET_ALL_QPPZ_LIST_BEGIN = 'USER_GET_ALL_QPPZ_LIST_BEGIN';
export const USER_GET_ALL_QPPZ_LIST_SUCCESS = 'USER_GET_ALL_QPPZ_LIST_SUCCESS';
export const USER_GET_ALL_QPPZ_LIST_FAILURE = 'USER_GET_ALL_QPPZ_LIST_FAILURE';
export const USER_GET_ALL_QPPZ_LIST_DISMISS_ERROR = 'USER_GET_ALL_QPPZ_LIST_DISMISS_ERROR';
export const USER_GET_ALL_MAKE_UNIT_ACTIONS_BEGIN = 'USER_GET_ALL_MAKE_UNIT_ACTIONS_BEGIN';
export const USER_GET_ALL_MAKE_UNIT_ACTIONS_SUCCESS = 'USER_GET_ALL_MAKE_UNIT_ACTIONS_SUCCESS';
export const USER_GET_ALL_MAKE_UNIT_ACTIONS_FAILURE = 'USER_GET_ALL_MAKE_UNIT_ACTIONS_FAILURE';
export const USER_GET_ALL_MAKE_UNIT_ACTIONS_DISMISS_ERROR = 'USER_GET_ALL_MAKE_UNIT_ACTIONS_DISMISS_ERROR';
export const USER_GET_QUERY_QPXX_ID_ACTIONS_BEGIN = 'USER_GET_QUERY_QPXX_ID_ACTIONS_BEGIN';
export const USER_GET_QUERY_QPXX_ID_ACTIONS_SUCCESS = 'USER_GET_QUERY_QPXX_ID_ACTIONS_SUCCESS';
export const USER_GET_QUERY_QPXX_ID_ACTIONS_FAILURE = 'USER_GET_QUERY_QPXX_ID_ACTIONS_FAILURE';
export const USER_GET_QUERY_QPXX_ID_ACTIONS_DISMISS_ERROR = 'USER_GET_QUERY_QPXX_ID_ACTIONS_DISMISS_ERROR';
export const USER_HADLE_TONG_BU_ACTIONS_BEGIN = 'USER_HADLE_TONG_BU_ACTIONS_BEGIN';
export const USER_HADLE_TONG_BU_ACTIONS_SUCCESS = 'USER_HADLE_TONG_BU_ACTIONS_SUCCESS';
export const USER_HADLE_TONG_BU_ACTIONS_FAILURE = 'USER_HADLE_TONG_BU_ACTIONS_FAILURE';
export const USER_HADLE_TONG_BU_ACTIONS_DISMISS_ERROR = 'USER_HADLE_TONG_BU_ACTIONS_DISMISS_ERROR';
export const USER_GET_TEMP_FILE_LIST_ACTION_BEGIN = 'USER_GET_TEMP_FILE_LIST_ACTION_BEGIN';
export const USER_GET_TEMP_FILE_LIST_ACTION_SUCCESS = 'USER_GET_TEMP_FILE_LIST_ACTION_SUCCESS';
export const USER_GET_TEMP_FILE_LIST_ACTION_FAILURE = 'USER_GET_TEMP_FILE_LIST_ACTION_FAILURE';
export const USER_GET_TEMP_FILE_LIST_ACTION_DISMISS_ERROR = 'USER_GET_TEMP_FILE_LIST_ACTION_DISMISS_ERROR';
export const USER_DEL_TEMP_FILE_ACTION_BEGIN = 'USER_DEL_TEMP_FILE_ACTION_BEGIN';
export const USER_DEL_TEMP_FILE_ACTION_SUCCESS = 'USER_DEL_TEMP_FILE_ACTION_SUCCESS';
export const USER_DEL_TEMP_FILE_ACTION_FAILURE = 'USER_DEL_TEMP_FILE_ACTION_FAILURE';
export const USER_DEL_TEMP_FILE_ACTION_DISMISS_ERROR = 'USER_DEL_TEMP_FILE_ACTION_DISMISS_ERROR';
export const USER_ADD_TEMP_FILE_ACTION_BEGIN = 'USER_ADD_TEMP_FILE_ACTION_BEGIN';
export const USER_ADD_TEMP_FILE_ACTION_SUCCESS = 'USER_ADD_TEMP_FILE_ACTION_SUCCESS';
export const USER_ADD_TEMP_FILE_ACTION_FAILURE = 'USER_ADD_TEMP_FILE_ACTION_FAILURE';
export const USER_ADD_TEMP_FILE_ACTION_DISMISS_ERROR = 'USER_ADD_TEMP_FILE_ACTION_DISMISS_ERROR';
export const USER_SHOW_ADD_MODAL = 'USER_SHOW_ADD_MODAL';
export const USER_GET_FRUI_QPPZ_LIST_BEGIN = 'USER_GET_FRUI_QPPZ_LIST_BEGIN';
export const USER_GET_FRUI_QPPZ_LIST_SUCCESS = 'USER_GET_FRUI_QPPZ_LIST_SUCCESS';
export const USER_GET_FRUI_QPPZ_LIST_FAILURE = 'USER_GET_FRUI_QPPZ_LIST_FAILURE';
export const USER_GET_FRUI_QPPZ_LIST_DISMISS_ERROR = 'USER_GET_FRUI_QPPZ_LIST_DISMISS_ERROR';
export const USER_SUBMIT_FRUI_QPPZ_BEGIN = 'USER_SUBMIT_FRUI_QPPZ_BEGIN';
export const USER_SUBMIT_FRUI_QPPZ_SUCCESS = 'USER_SUBMIT_FRUI_QPPZ_SUCCESS';
export const USER_SUBMIT_FRUI_QPPZ_FAILURE = 'USER_SUBMIT_FRUI_QPPZ_FAILURE';
export const USER_SUBMIT_FRUI_QPPZ_DISMISS_ERROR = 'USER_SUBMIT_FRUI_QPPZ_DISMISS_ERROR';
export const USER_DELETE_FRUI_QPPZ_BEGIN = 'USER_DELETE_FRUI_QPPZ_BEGIN';
export const USER_DELETE_FRUI_QPPZ_SUCCESS = 'USER_DELETE_FRUI_QPPZ_SUCCESS';
export const USER_DELETE_FRUI_QPPZ_FAILURE = 'USER_DELETE_FRUI_QPPZ_FAILURE';
export const USER_DELETE_FRUI_QPPZ_DISMISS_ERROR = 'USER_DELETE_FRUI_QPPZ_DISMISS_ERROR';
export const USER_FRUI_QPPZ_MODAL_CHANGE = 'USER_FRUI_QPPZ_MODAL_CHANGE';
export const USER_CHOOSE_CURRENT_FRUI_QPPZ = 'USER_CHOOSE_CURRENT_FRUI_QPPZ';










// WEBPACK FOOTER //
// ./src/features/user/redux/constants.js